module.exports = __webpack_public_path__ + "img/o8.9cbcdeac.png";